<template>
  <div>
		<span class="item" @click="showDegreeModel">
			<span class="icon-f1"></span>
			{{ addType ? (eqInfo.airVentilator.workingMode1 === '0' ? '制冷' : '制热') : '' }}温度设定
		</span>

    <!--    温度切换-->
    <mt-popup v-model="popup">
      <div class="smart-modal">
        <h1>温度设定</h1>
        <input v-show="eqInfo.airVentilator.workingMode1==='0'" type="number" v-model="settingVal"
               placeholder='温度18.0~27.0℃'>
        <input v-show="eqInfo.airVentilator.workingMode1==='1'" type="number" v-model="settingVal"
               placeholder='温度18.0~30.0℃'>
        <div class="smart-modal-foot">
          <span @click="hideModal">取消</span>
          <span @click="onSubmit">确定</span>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import {Range, Toast, Popup, Radio, Indicator} from 'mint-ui';

export default {
  name: 'eqSetDegree',
  props: ['eqInfo', 'id', 'addType'],
  data() {
    return {
      settingVal: '',
      popup: false,
      degrees: 0,
      valueDegrees: [],
      hotMain: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center',
          value: 15,
          defaultIndex: 10
        }
      ],
      coolMain: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center',
          value: 15,
          defaultIndex: 5
        }
      ],
      slotsFan: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center'
        }
      ]
    };
  },
  beforeMount() {
    // 温度
    // 新风制冷23-30
    let mainCool = [];
    for (let i = 23; i <= 30; i++) {
      mainCool.push(i);
    }
    this.coolMain[0].values = mainCool;

    // 新风制热18-27
    let mainHot = [];
    for (let i = 18; i <= 27; i++) {
      mainHot.push(String(i));
    }
    this.hotMain[0].values = mainHot;
  },
  methods: {
    getId() {
      return this.id;
    },
    getDegree() {
      let data = this.eqInfo;
      let degrees = 0;
      // 获取设定温度
      if (data.airVentilator.workingMode1 === '0') {
        degrees = this.eqInfo.airVentilator.homeCoolingTemperatureSetting;
      }

      if (data.airVentilator.workingMode1 === '1') {
        degrees = this.eqInfo.airVentilator.homeHeatingTemperatureSetting;
      }

      if (data.airVentilator.workingMode1 === '3') {
        degrees = this.eqInfo.airVentilator.homeHeatingTemperatureSetting;
      }
      return degrees;
    },
    showDegreeModel() {
      let degrees = this.getDegree();
      if (this.eqInfo.airVentilator.workingMode1 === '0') {
        this.coolMain[0].defaultIndex = degrees - 7;
      }
      if (this.eqInfo.airVentilator.workingMode1 === '1') {
        this.hotMain[0].defaultIndex = degrees - 15;
      }
      this.popup = true;
    },

    onValuesChange(picker, values) {
      this.valueDegrees = values;
    },
    onSubmit() {
      let settingVal = this.settingVal;
      let condition = this.eqInfo.airVentilator.workingMode1;
      if (condition === '0') {
        if ((settingVal <= 27) & (settingVal >= 18)) {
          this.adjustCoolTemperature(settingVal);
        } else {
          Toast('请输入正确的温度值');
        }
      } else if (condition === '1') {
        if ((settingVal <= 30) & (settingVal >= 18)) {
          this.adjustHeatTemperature(settingVal);
        } else {
          Toast('请输入正确的温度值');
        }
      }
      this.popup = false;
    },

    changeDegree() {
      let degree = this.valueDegrees[0];
      if (this.eqInfo.airVentilator.workingMode1 === '0') {
      } else if (this.eqInfo.airVentilator.workingMode1 === '1') {
        this.adjustHeatTemperature(degree);
      }
    },

    // 调节制热温度
    adjustHeatTemperature(temperature) {
      let data = {
        "iotDeviceId": parseInt(this.getId()),
        "heatTemp": temperature
      }
      this.Api.freshAdjustHeatTemperature(data, msg => {
        // this.cancelDegreeModel();
        if (msg.code === 200) {
          this.$emit('init');
          // Toast('设置制热温度成功')
        } else {
          Toast(msg.message);
        }
      });
    },
    // 调节制冷温度
    adjustCoolTemperature(temperature) {
      // let arr = [];
      // arr.push('id=' + this.getId());
      // arr.push('equipmentCoolTemperature=' + temperature);
      // let str = arr.join('&');

      let data = {
        "iotDeviceId": parseInt(this.getId()),
        "coolTemp": temperature
      }
      this.Api.freshAdjustCoolTemperature(data, msg => {
        // this.cancelDegreeModel();
        if (msg.code === 200) {
          this.$emit('init');
          // Toast('设置制冷温度成功')
        } else {
          Toast(msg.message);
        }
      });
    },
    hideModal() {
      this.popup = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/commen/eqSetDegree/index.vue